module.exports = __webpack_public_path__ + "static/images/components/TutorialArrow/images/tutorial-arrow.fbb1e9b9.png";


//////////////////
// WEBPACK FOOTER
// ./components/TutorialArrow/images/tutorial-arrow.png
// module id = 2678
// module chunks = 11